import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom'; // Add this import
import { LoginPage } from './components/LoginPage';
import { Navigation } from './components/Navigation';
import { Dashboard } from './components/DashBoard';
import { ProfilePage } from './components/ProfilePage';
import { RewardsPage } from './components/RewardsPage';
import { LoyaltyTiersPage } from './components/LoyaltyTiersPage';
import { SettingsPage } from './components/SettingsPage';
import { Footer } from './components/Footer';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { AppRoutes } from './routes'; // Now we'll use this
import subtle_bg from './assets/background_scroll.png';

// New wrapper for authenticated tabbed content
const AuthenticatedApp = ({ user, handleLogout }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard userPhone={user.phoneNumber} />;
      case 'profile':
        return <ProfilePage userPhone={user.phoneNumber} />;
      case 'rewards':
        return <RewardsPage />;
      case 'loyalty':
        return <LoyaltyTiersPage />;
      case 'settings':
        return <SettingsPage onLogout={handleLogout} />;
      default:
        return <Dashboard userPhone={user.phoneNumber} />;
    }
  };

  return (
    <div className={`relative min-h-screen`}>
      {/* Conditional Background */}
      <div
        className="fixed inset-0 z-0"
        style={{
          backgroundImage: `url(${subtle_bg})`, // Replace with your subtle background image
          backgroundSize: 'cover', // Adjust based on your image
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center',
          opacity: 0.4, // Very subtle opacity
        }}
      />
      <div className="relative z-10">
        <Navigation
          activeTab={activeTab}
          onTabChange={setActiveTab}
          isMobileMenuOpen={isMobileMenuOpen}
          onMobileMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          onLogout={handleLogout}
        />
        <main className="min-h-screen">
          {renderContent()}
        </main>
        <Footer />
        {/* {activeTab === 'dashboard' && <Footer />} */}
      </div>
    </div>
  );
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = (phoneNumber) => {
    console.log("Logged in:", phoneNumber);
    // No need for manual redirect; routing will handle it
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setUser(null);
      window.location.reload(); // Or use navigate if you want smoother redirect
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
      </div>
    );
  }

  return (
    <> {/* Wrap entire app with BrowserRouter */}
      <AppRoutes user={user} handleLogout={handleLogout} onLogin={handleLogin} /></>

  );
}

export default App;
export { AuthenticatedApp }; 